console.log('process.env', process.env)
export default {
    api: (process.env.REACT_APP_API_BASEURL || 'http://54.82.101.184:3000/api'),
    api_host: (process.env.REACT_APP_API_HOST || 'http://54.82.101.184:3000'),
    socket: (process.env.REACT_APP_SOCKET || 'http://54.82.101.184:3000'),
    player: (process.env.REACT_APP_PLAYER_URL || 'http://54.82.101.184:3002'),
}